









import { computed, defineComponent, PropType } from '@vue/composition-api';
import { AnyLearningItem } from '../Model';
import { getLearningProgramsStore } from '../store/LearningProgramsStore';
import { sumCredits } from '../util/util';

export default defineComponent({
	props: {
		learningItem: {
			type: Object as PropType<AnyLearningItem>,
			required: true,
		},
		hideIfZero: Boolean,
	},
	setup(props) {
		const programsStore = getLearningProgramsStore();
		const totalCredits = computed(() => sumCredits(props.learningItem, programsStore));
		return {
			totalCredits,
		};
	},
});
